export const getReferral = () => {
  const rewardful = window.Rewardful || {}

  return rewardful.referral
}
